import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stopHand:'',
    path:'3',
    roletype:'',
    fontSize:'',//字体
    colorData:'',//颜色
    titleList:'',//标题
    logo:'',//图片
    uuidMap:'',//地图uuid
    userBox:'',//账号 密码
    jxs:'',
    kh:'',
    jxsTree:'',
    SHQ:'',
    homeTree:'',
    khData:{},
    wangData:{},
    nameTiles:'',
    faly:'',
    abckground:'',
    dataObjsstytem:{},//获取所有系统信息
    treeState:'',
    getUUId:''
  },
  mutations: {
    // 关闭摄像头声音
    stopCkick(state,data){
      // console.log(data)
      state.stopHand = data
    },
    // 实时数据记录
    shshListData(state,data){
      state.nameTiles = data
    },
    // 摄像头uuid
    getUUid_value(state,data){
      state.getUUId = data

    },
    // flag
    falgClick(state,data){
      state.faly = data
    },
    // 客户记录
    kehuClick(state,data){
      state.khData = data
    },
    // 首页的记录信息
    homeClick(state,data){
      state.homeTree = data
    },
    pathUrl(state,url){
      state.path = url
    },
    roletypeValue(state,value){
      state.roletype = value
      // console.log(value);
    },
    //字体大小
    fontClick(state,data){
      state.fontSize = data
      // console.log('222')
    },
    // 标题
    titleClick(state,data){
      state.titleList = data
    },
    //图片
    LogoClick(state,data){
      state.logo = data
    },
    // 网关设置
    wangGunData(state,data){
      state.wangData = data

    },
    // 根据地uuid获取当前位置
    uuidClick(state,data){
      // console.log(data);
      state.uuidMap = data

    },
    ColorClick(state,data){
      // console.log(data)
      state.colorData=data
    },
    //账号 密码
    formLabelAlign(state,data){
      // console.log(data);
      state.userBox = data
    },
    // 经销商
    myJxs(state,data){
      state.jxs = data
    },
    // 经销商的树
    myjxsData(state,data){
      // alert(data)
      state.jxsTree = data
    },
    //客户
    kehu(state,data){
      state.kh = data
    },
    // 省市区
    jxsSQ(state,data){
      state.SHQ = data
    },
    //给侧边栏改变颜色
    myLeftNav(state,data){
      state.abckground = data
    },
    bugFlay(state,data){
      state.dataObjsstytem = data
    },
    // 更新菜单栏数据
    supperData(state,data){
      // console.log(data);
      state.treeState = data
      

    },
  },
  actions: {
  },
  modules: {
  }
})
